import { useSyncExternalStore } from "react";

/**
 * CRS-15: the Cohorts panel and the Zoom Q&A / Deadlines panels each load the course's cohorts.
 * When one creates or deletes a cohort, the others refetch — no reload needed.
 */
const versions = new Map<string, number>();
const listeners = new Set<() => void>();

export function notifyCohortsChanged(courseId: string): void {
  versions.set(courseId, (versions.get(courseId) ?? 0) + 1);
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Changes whenever a cohort of this course is created or deleted; use it as an effect dependency. */
export function useCohortsVersion(courseId: string): number {
  return useSyncExternalStore(
    subscribe,
    () => versions.get(courseId) ?? 0,
    () => 0,
  );
}
